import React from 'react';
import isInteger from 'lodash/isInteger';
import range from 'lodash/range';
import styled from 'styled-components';
import { TBannerModuleStripTimer } from '@com/core/common/types/catalog';
import ModuleHeader from '../moduleHeader/moduleHeader';
import CountdownTimer from '../bannerTimer/CountdownTimer';
import BannerContent from '../bannerModule/bannerContent/bannerContent';

const commonSpace = 12;

const BannerWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    font-size: 16px;

    .bannerGroup & {
        flex: 1;
    }
`;

const BannerContainer = styled.div`
    flex: 1;
    box-sizing: border-box;
    position: relative;
`;

const TimerContainer = styled.div<{ color?: string }>`
    background-size: cover;
    color: ${({ color }: { color?: string }): string => color || '#fff'};
    font-weight: bold;
    padding: 5px;
`;

type TProps = {
    moduleData: TBannerModuleStripTimer;
};

const TimerWrapper = styled.div`
    position: absolute;
    right: ${commonSpace * 3}px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    direction: ltr;
`;

const BannerModuleStripTimer = ({ moduleData }: TProps): JSX.Element => {
    const { banners, moduleHeader, textColor, type } = moduleData;
    const { numPerRow, timer } = moduleData;
    const innerSpacingValues = range(0, 20, 5);

    const bannerWrapper = {};
    let bannerContainer = {};

    // SET CUSTOM PADDING FOR STANDARD GRID BANNERS
    // DEFAULT 15px. ie: 3rd in innerSpacingValues
    const innerSpacing =
        moduleData && {}.hasOwnProperty.call(moduleData, 'innerSpacing') ? moduleData.innerSpacing : null;

    if (isInteger(innerSpacing)) {
        const paddingPx =
            innerSpacing && innerSpacingValues[innerSpacing] ? innerSpacingValues[innerSpacing] : commonSpace;

        bannerContainer = {
            padding: `0px 0px ${paddingPx}px ${paddingPx}px`,
        };
    }

    return (
        <div>
            {moduleHeader && <ModuleHeader className="siteWidthContainer" data={moduleHeader} textColor={textColor} />}
            <BannerWrapper className="siteWidthContainer" style={bannerWrapper}>
                {banners.map(banner => {
                    const bannerClassList =
                        typeof numPerRow === 'number' && numPerRow > 1 ? 'standardBanner' : 'featureBanner';
                    return (
                        <BannerContainer
                            key={banner.imageUrl}
                            style={
                                numPerRow
                                    ? {
                                          ...bannerContainer,
                                          flex: `0 0 ${(1 / numPerRow) * 100}%`,
                                      }
                                    : {}
                            }>
                            <BannerContent bannerStyle={`${type} ${bannerClassList}`} bannerData={banner} />
                            {timer && (
                                <TimerWrapper
                                    style={
                                        timer.coordinates
                                            ? {
                                                  left: `${timer.coordinates.x}`,
                                                  top: `${timer.coordinates.y}`,
                                                  transform: `translate(-${timer.coordinates.x}, -${timer.coordinates.y})`,
                                              }
                                            : {}
                                    }>
                                    <TimerContainer>
                                        <CountdownTimer
                                            endTime={timer.expiry}
                                            disableDays={timer.disableDays ? timer.disableDays : false}
                                            displayUnitsBottom={
                                                timer.displayUnitsBottom ? timer.displayUnitsBottom : false
                                            }
                                            isSlider={false}
                                            timerFontSize={timer.fontSize ? `${timer.fontSize}` : ''}
                                        />
                                    </TimerContainer>
                                </TimerWrapper>
                            )}
                        </BannerContainer>
                    );
                })}
            </BannerWrapper>
        </div>
    );
};

export default BannerModuleStripTimer;
